import { MODAL_DATA_ACTIONS } from "../Actions/modalActions";
import { log } from "../../Helpers/logger";

const MODAL_INITIAL_STATE = {
    displayModal: { 
        show: false, 
        flag: null, 
        data: {},
    }
};

export const modalReducer = (state = MODAL_INITIAL_STATE, action) => {
    log.reducer.log('modalReducer - Action reçue:', action);
    log.reducer.log('modalReducer - État actuel:', state);

    switch (action.type) {
        case MODAL_DATA_ACTIONS.SWITCH: {
            return {
                ...state,
                show: !state.show, 
            };
        }
        case MODAL_DATA_ACTIONS.SET_FLAG: {
            const { flag } = action.payload;

            return {
                ...state,
                flag
            }
        }
        case MODAL_DATA_ACTIONS.SET_DATA: {
            const { data } = action.payload;

            return {
                ...state,
                data
            }
        }
        case MODAL_DATA_ACTIONS.SET: {
            const { showModal, flag, data } = action.payload;

            return {
                ...state,
                show: showModal,
                flag,
                data
            }
        }
    } 
    return state;
}